import { __assign } from "tslib";
import LAYOUTS from '../../common/constants/layout';
import { calcTargetItemSize } from '../helpers/layoutHelper';
export var fixedStyles = {
    galleryLayout: LAYOUTS.GRID,
    cubeImages: true,
    isVertical: true,
    groupSize: 1,
    hasThumbnails: false,
    groupTypes: '1',
    slideshowLoop: false,
    // this params were moved from the presets in layoutHelper and were not tested and checked yet.
    smartCrop: false,
    galleryType: 'Columns',
    fixedColumns: 0,
    targetItemSize: 0,
    enableScroll: true,
    cropOnlyFill: false,
    isSlider: false,
    isColumns: false,
    isGrid: true,
    isMasonry: false,
    isSlideshow: false,
    minItemSize: 50,
};
export var createStyles = function (styles) {
    return __assign(__assign(__assign({}, styles), fixedStyles), { targetItemSize: calcTargetItemSize(styles, Math.round(styles.gallerySize * 8.5 + 150)) });
};
//# sourceMappingURL=gridGallery.js.map